import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
//import { makeStyles } from '@mui/styles';
import styled from '@emotion/styled'
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ParkOutlined from '@mui/icons-material/ParkOutlined';
import { Button, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import useMediaQuery from '@mui/material/useMediaQuery';
import NewStore from './NewStore';
//const drawerWidth = 270;
const drawerWidth = 200;
//const drawerWidth = 'auto';


const useStyles = styled({
    drawer:{
    },
    listCLass:{
    },
    listItem: {
        marginBottom: 4,
        backgroundColor: '#F1F6FA',
        borderRadius: '16px',
        height: '40px',
        padding: '0px',
    },
    MenuBtn:{
         display: 'flex',
        justifyContent:'space-between',
        alignItems: 'center',
        maxHeight:40,
         gap: '12px',   
         padding:0 
    },
    itemText:{
        color:'#172128',
        fontSize: '6px',
        fontFamily: 600,
        lineHeight: '16px'
    },
    menuHeading:{
        width: '178px',
        gap: '12px',
        paddingLeft: '12px',
        color:'#808C96',
        fontSize: '34px',
        fontWeight: 600,
        lineHeight: '16px'
    },
    searchBox: {
      width:436,
      borderRadius:18
    },
    iconBox: {
      marginLeft: 'auto',
      marginRight: 10,
      width: 48,
      height: 48,
      borderRadius:24,
      top:12,
      padding: 6,
      gap:15,
     backgroundColor:'#FA4B16',
      alignItems:'center',
      justifyContent:'center',
      alignContent:'center',
      textAlign:'center'
     },
  });


export default function Sidebar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const classes = useStyles();

  const [openSubMenuIndex, setOpenSubMenuIndex] = React.useState(false);

  const handleSubMenuClick = (index) => {
    if (openSubMenuIndex === index) {
      setOpenSubMenuIndex(null);
    } else {
      setOpenSubMenuIndex(index);
    }
  };

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const drawer = (
    <div>
      {/* <Toolbar /> */}
      <div style={{display: 'inline-flex',gap:8, backgroundColor: '#FFFFFF',padding:12,borderRadius:'16px' }}>
      <img
       src={require('../../Assets/logo.png')}
        alt={"logo"}
        loading="lazy"
        style={{height:48,height:48}}
      />
        {/* <Button variant="outlined" style={{ width : '100%',color:'#FFFFFF', fontSize: '12px', fontWeight: 600,alignSelf: 'stretch', borderColor:'#172128',color:'#FFF', backgroundColor:'#172128',borderRadius: '12px',padding:'12px', gap: '12px',alignItems:'center', }}> */}
        <div style={{
          backgroundColor:'#172128',
          width:122,
          height:48,
          borderRadius:12,
          padding:6,
          gap:15,
          alignItems:'center',
          display: 'flex',
          justifyContent:'center'
        }}>
        <Typography style={{
          color:'#FFFFFF', fontSize: '12px', fontWeight: '500'
        }}>
        Self Service Portal
        </Typography>
        </div>
        {/* </Button> */}
      </div>
        <Divider sx={{marginLeft:1,marginRight:1}}/>
        <Typography variant="body1" component="body1" style={{ fontSize: '12px',fontWeight:600,lineHeight:'16px',margin:12, color: '#808C96' }}>
          favourites
        </Typography>
        <div style={{margin:12}}>
          <List className={classes.listCLass}>
            {['item Images', 'Generate PO PDF'].map((text, index) => (
              <>
                <ListItem key={text} className={classes.listItem}  
                disablePadding> 
                  <ListItemButton 
                    className={classes.MenuBtn} 
                    onClick={() => handleSubMenuClick(index)}
                    sx={{
                      borderRadius: '16px',
                      '&:hover': {
                        borderRadius: '16px',
                      
                      },
                    }}
                    >
                    <ListItemText sx={{ my: 0 }} primary={text} 
                      primaryTypographyProps={{
                      fontSize: 12,
                      fontWeight: 600
                      }}/>
                      {openSubMenuIndex === index ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                </ListItem>
                {openSubMenuIndex === index && (
                  <List component="div" disablePadding>
                    <ListItemButton >
                      <ListItemText primary="Submenu Item 1" />
                    </ListItemButton>
                    <ListItemButton >
                      <ListItemText primary="Submenu Item 2" />
                    </ListItemButton>
                  </List>
                )}
              </>
            ))}
          </List>
        </div>
        <Divider sx={{marginLeft:1,marginRight:1}}/>
        <Typography variant="body1" component="body1" style={{ fontSize: '12px',fontWeight:600,lineHeight:'16px',margin:12, color: '#808C96' }}>
          all Modules
        </Typography>
        <div style={{margin:12}}>
          <List className={classes.listCLass}>
              {['assortment', 'indent', 'manual TO', 'PO Management'].map((text, index) => (
              <ListItem key={text} className={classes.listItem} disablePadding>
                  <ListItemButton className={classes.MenuBtn}
                    sx={{
                    borderRadius: '16px',
                    '&:hover': {
                      borderRadius: '16px',
                    },
                  }}
                  >
                      <ListItemText sx={{ my: 0 }} primary={text} 
                      primaryTypographyProps={{
                      fontSize: 12,
                      fontWeight: 600,
                      }}/>
                      <ExpandMore />
                  </ListItemButton>
              </ListItem>
              ))}
          </List>
        </div>
        <div style={{margin:12, backgroundColor: '#172128',gap :'12px', padding:12,borderRadius:'16px' }}>
          <div style={{display:'inline-flex',padding:12,paddingBottom:0,justifyContent:'space-between',alignItems:'center',width:'100%'}}>
          <Typography variant="body1" component="body1" style={{ color:'#FFFFFF', fontSize: '12px', fontWeight: 600,lineHeight: '16px' }}>
              New Store Opening
          </Typography>
          <ExpandLess sx={{color:'#FFFFFF', fontSize: '12px', fontWeight: 600,}} />
          </div>
          <Divider style={{backgroundColor:'#38444C',margin:12}} />
          <Button variant="outlined" style={{ width : '100%',color:'#FFFFFF', fontSize: '12px', fontWeight: 600,lineHeight: '16px',alignSelf: 'stretch', borderColor:'#FA4B16',color:'#FFF', backgroundColor:'#FA4B16',borderRadius: '12px',padding:'12px', gap: '12px',alignItems:'center', }}>
          <ParkOutlined style={{height:16,width:16}} /> PPI & RAI
          </Button>
        </div>
        <div style={{margin:12}}>
          <List>
              {['PBI', 'Master Data MAn', 'fusion','auto delisting','more heroes','visibility v2','TOT Portal','vendor portal','benchmarking'].map((text, index) => (
              <ListItem key={text} className={classes.listItem} 
              disablePadding
              >
                <ListItemButton className={classes.MenuBtn}
                sx={{
                  borderRadius: '16px',
                  '&:hover,&:focus': {
                    borderRadius: '16px',
                  },
                }}
                >
                    <ListItemText sx={{ my: 0 }} primary={text} 
                    primaryTypographyProps={{
                        fontSize: 12,
                        fontWeight: '600',
                    }}
                    />
                    <ExpandMore />
                </ListItemButton>
              </ListItem>
              ))}
          </List>
        </div>
      </div>
    );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          backgroundColor:'white',
          height:72,
          boxShadow: 'none'
        }}
       // elevation={1}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, backgroundColor:'#FA4B16', display: { sm: 'none' } }}
          >
          <MenuIcon />
          </IconButton>
          <Box className="w-full" sx={{  borderRadius: 18, backgroundColor: '#F1F6FA', width: 436,height:48 }}>
            <div className="w-[90%]" style={{display:'inline-flex',alignItems:'center',justifyContent:'center', paddingLeft:12}}>
            <SearchIcon style={{color:'black',marginTop:4,height:16,width:16}}/>
            <input
              type="text"
              id="input-group-1"
              style={{
                marginTop:4,
                height:36,
                width:'100%',
                marginLeft:12,
                backgroundColor:'#F1F6FA',
                fontSize: 16,
                lineHeight:24,
                fontWeight:'400'
              }}
              placeholder="Search your module"
             
            />
            </div>
          </Box>
         
          <div className={classes.iconBox} >
          <Typography  style={{color:'#FFF'}}>AR</Typography>
          </div>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
           variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ 
          flexGrow: 1,
          //p: 3,
          marginTop:3,
           width: { sm: `calc(100% - ${drawerWidth}px)` } 
        }}
      >
        <NewStore/>
      </Box>
    </Box>
  );
}
